import { UserModel } from '../../../interfaces/user.interface';
import {
  createInvitedUserSubscriptionSessionAndRedirect,
  createSubscriptionSessionAndRedirect,
} from '../../../services/SelectPlanPurchase.service';
import { auth } from '../../../firebase';
import { openPlanPurchaseModal } from '../../../store/appSlice';
import { AppDispatch } from '../../../store/store';
import { NavigateFunction } from 'react-router-dom';
import { setRedirectURL } from '../../../store/userSlice';
import { getCurrencyForCountry } from '../../../config/currencies';
import { allCurrencies, CurrencyEnum } from '../../../interfaces/plan.interface';

export const autoSubscribeOnThePlan = (
  planId: string,
  currencyCode: string | null | undefined,
  user: UserModel,
  dispatch: AppDispatch,
  navigateTo: NavigateFunction,
  finallyCallback?: () => void,
) => {
  if (!!user.isTrialFreeAccess || !user.subscribedOnPlanAt || (!user?.planRef && !user?.plan)) {
    // Get user's currency based on their country
    const userCountry = user?.shippingCountry || user?.detectedCountry;
    const userCurrency =
      currencyCode && allCurrencies.includes(currencyCode?.toLowerCase())
        ? (currencyCode as CurrencyEnum)
        : userCountry
          ? getCurrencyForCountry(userCountry)
          : undefined;

    createSubscriptionSessionAndRedirect(planId, user?.email!, dispatch, true, -1, false, userCurrency, () =>
      navigateToUserPlans(dispatch, navigateTo, '/'),
    )
      .then()
      .catch()
      .finally(() => finallyCallback && finallyCallback());
  } else {
    navigateToUserPlans(dispatch, navigateTo);
  }
};

export const autoSubscribeOnThePlanFromInvitationToken = (
  token: string,
  user: UserModel,
  dispatch: AppDispatch,
  navigateTo: NavigateFunction,
  finallyCallback?: () => void,
) => {
  createInvitedUserSubscriptionSessionAndRedirect(token, user?.email!, dispatch, true, () =>
    navigateToUserPlans(dispatch, navigateTo, '/'),
  )
    .then()
    .catch()
    .finally(() => finallyCallback && finallyCallback());
};

export const navigateToUserPlans = (dispatch: AppDispatch, navigateTo: NavigateFunction, locationPath?: string) => {
  if (!auth.currentUser) {
    dispatch(setRedirectURL('/'));
    return;
  }
  dispatch(setRedirectURL(locationPath || '/myPlans'));

  setTimeout(() => {
    dispatch(
      openPlanPurchaseModal({
        show: true,
        data: {
          title: 'Purchase plan!',
          description:
            "Order a physical copy of the book you're creating, or subscribe to a limited-time free trial to finish your current story and start new ones!",
        },
      }),
    );
  });
};
